import { useQuery } from 'react-query';
import { axios } from 'lib/axios';

export const getApplications = ({ jobAdID, page, limit = 10, search }) => {
  return axios.get(`/api/job_ads/${jobAdID}/applications`, {
    params: { offset: page * limit, limit, ...(search ? { search } : {}) },
  });
};

export const useApplications = (jobAdID, { page, limit = 10, search = '', queryOptions }) => {
  const { data, ...rest } = useQuery(
    ['job-ad-applications', jobAdID, page, limit, search],
    () => getApplications({ jobAdID, page, limit, search }),
    {
      ...queryOptions,
      select: ({ data }) => ({
        applications: data.data || [],
        total: data.total || 0,
      }),
    }
  );

  return { data: data || { applications: [], total: 0 }, ...rest };
};
